import { useState } from "react";
import { APIEndpoints } from "../constants/APIEndpoints";
import BaseClient from "../helper/Baseclient";

const useMenus = () => {
  const [menuItems, setMenuItems] = useState(null);
  const [menuLoading, setMenuLoading] = useState(false);

  const fetchMenuItems = async (token) => {
    try {
      setMenuLoading(true);
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      await BaseClient.get(
        APIEndpoints.fetchMenuList,
        {},
        {
          onSuccess: (res) => {
            setMenuItems(res?.menuList);
          },
          onFailed: (err) => {
            console.log("Error fetching menu items:", err);
          },
          headers,
        }
      );
    } catch (error) {
      console.log("Error fetching menu items:", error);
    } finally {
      setMenuLoading(false);
    }
  };

  return {
    menuItems,
    menuLoading,
    fetchMenuItems,
  };
};

export default useMenus;
